<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <argon-input type="text" v-model="form.ref" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Código de barras</label>
                <div class="input-group">
                  <input type="text" class="form-control" v-model="form.barcode" />
                  <button
                    type="button"
                    class="btn btn-outline-secondary mb-0"
                    title="Imprimir código de barras"
                    @click="openPrintModal(form.barcode, form.name, form.sale_price)"
                    style="border-right: 1px solid #000000 !important;border-left: 1px solid #000000 !important;"

                  >
                    <i class="fas fa-barcode"></i>
                  </button>
                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <argon-input type="text" v-model="form.quantity" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de venta</label>
                <argon-input type="text" v-model="form.sale_price" />
              </div>

              

              <div class="col-md-12 d-flex align-items-center mt-4 mb-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="manageStock"
                    v-model="form.manage_stock"
                  />
                  <label class="form-check-label ms-2" for="manageStock">
                    Manejar stock del insumo
                  </label>
                </div>
              </div>

              <br>
              <hr>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant mininima</label>
                <argon-input type="text" v-model="form.low" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant media</label>
                <argon-input type="text" v-model="form.medium" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant alta</label>
                <argon-input type="text" v-model="form.high" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>

      <!-- Tabla de variantes del producto -->
      <div class="col-12" v-if="form.id != 0 && form.shopify_details && form.shopify_details.variants && form.shopify_details.variants.length > 0">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <h6>Variantes del Producto (Shopify)</h6>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Título
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      SKU
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Precio
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Gramos
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      ID Shopify
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Código de barras
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(variant, index) in form.shopify_details.variants" :key="index">
                    <td class="align-middle text-sm">
                      {{ variant.title || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.sku || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.price ? Number(variant.price).toLocaleString('es-ES', { minimumFractionDigits: 0 }) : '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.grams || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.id || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control form-control-sm" v-model="variant.barcode" placeholder="Código de barras" />
                        <button
                          type="button"
                          class="btn btn-outline-secondary mb-0"
                          title="Imprimir código de barras"
                          @click="openPrintModal(variant.barcode, form.name + (variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : ''), variant.price || form.sale_price)"
                          style="border-right: 1px solid #000000 !important;border-left: 1px solid #000000 !important;"
                        >
                          <i class="fas fa-barcode"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal de impresión de código de barras -->
    <div v-if="showPrintModal" class="barcode-modal-overlay" @click.self="closePrintModal">
      <div class="barcode-modal card shadow">
        <div class="card-body">
          <h6 class="mb-3">Imprimir código de barras</h6>

          <div v-if="!printData.barcode" class="alert alert-warning py-2 text-sm">
            Este producto no tiene un código de barras asignado.
          </div>

          <template v-else>
            <div class="mb-3">
              <label class="form-control-label">Cantidad de etiquetas a imprimir</label>
              <input type="number" min="1" class="form-control" v-model.number="printData.quantity" />
            </div>

            <p class="text-xs text-muted mb-2">Vista previa de la etiqueta (100 x 50 mm)</p>
            <div class="barcode-preview-wrapper">
              <div class="barcode-label" ref="labelPreview">
                <div class="barcode-label-header">
                  <span class="barcode-label-name">{{ printData.name || 'PRODUCTO' }}</span>
                  <span class="barcode-label-price">{{ formatPrice(printData.price) }}</span>
                </div>
                <div class="barcode-label-body">
                  <svg ref="previewSvg"></svg>
                </div>
              </div>
            </div>
          </template>

          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="closePrintModal">Cancelar</button>
            <button
              v-if="printData.barcode"
              type="button"
              class="btn btn-success btn-sm"
              @click="printLabels"
            >
              <i class="fas fa-print me-1"></i> Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import JsBarcode from 'jsbarcode';
import inventoryService from '../../../services/inventory.service';
import 'select2/dist/css/select2.css';
import 'select2';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      form: {
        id: 0,
        name: '',
        ref: '',
        description: '',
        barcode: '',
        quantity: 0,
        status: 1,
        bodega_id: null,
        price: 0,
        sale_price: 1,
        manage_stock: true,
        low: 100,
        medium: 200,
        high: 300,
      },
      bodegas: [],
      showPrintModal: false,
      printData: {
        barcode: '',
        name: '',
        price: 0,
        quantity: 3,
      },
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  methods: {
    formatPrice(value) {
      const num = Number(value) || 0;
      return '$' + num.toLocaleString('es-CO', { minimumFractionDigits: 0 });
    },
    openPrintModal(barcode, name, price) {
      this.printData = {
        barcode: barcode ? String(barcode).trim() : '',
        name: (name || '').toUpperCase(),
        price: price || 0,
        quantity: 3,
      };
      this.showPrintModal = true;
      if (this.printData.barcode) {
        this.$nextTick(() => this.renderPreviewBarcode());
      }
    },
    closePrintModal() {
      this.showPrintModal = false;
    },
    renderPreviewBarcode() {
      if (!this.$refs.previewSvg) return;
      try {
        JsBarcode(this.$refs.previewSvg, this.printData.barcode, {
          format: 'CODE128',
          displayValue: true,
          fontSize: 12,
          height: 50,
          margin: 0,
          width: 1,
        });
      } catch (e) {
        console.error('Error generando código de barras:', e);
      }
    },
    async printLabels() {
      const qty = Math.max(1, parseInt(this.printData.quantity) || 1);

      if (!this.printData.barcode) {
        Swal.fire('Error', 'No hay código de barras para imprimir.', 'error');
        return;
      }

      try {
        Swal.fire({
          title: 'Generando PDF...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });

        const response = await inventoryService.printBarcodeLabels({
          barcode: this.printData.barcode,
          name: this.printData.name || 'PRODUCTO',
          price: this.printData.price || 0,
          quantity: qty,
        });

        Swal.close();

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const printWindow = window.open(url, '_blank');
        if (!printWindow) {
          Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
          return;
        }

        this.closePrintModal();
      } catch (error) {
        Swal.close();
        console.error('Error generando PDF:', error);
        Swal.fire('Error', 'No se pudo generar el PDF de etiquetas.', 'error');
      }
    },
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
      if (this.bodegas && this.bodegas.length > 0 && !this.form.bodega_id) {
        this.form.bodega_id = this.bodegas[0].id;
      }
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar el formulario con los datos guardados
          if (response.data && response.data.data) {
            this.form.id = response.data.data.id || this.form.id;
          }
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El insumo ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Redirigir a la lista de inventario (mantener filtro de búsqueda si venía en la URL)
          const search = this.$route.query.search;
          this.$router.push({
            name: 'Inventory',
            query: search
              ? { search: Array.isArray(search) ? search[0] : search }
              : {},
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        const errData = error?.data || error?.response?.data;
        const msg = errData?.errors?.ref?.[0] || errData?.message || error?.message || 'Error al guardar el proyecto';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
  },
  mounted() {
    this.getBodegas();

    const dataEdit = this.$route.params.data;

    console.log(dataEdit);

    if (dataEdit) {
      try {
        const params = JSON.parse(dataEdit);

        if (params && params.id) {
          this.form = {
            ...this.form,
            ...params,
            manage_stock: this.normalizeBoolean(params.manage_stock),
          };
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }

    if (this.form.id === 0 && !this.form.barcode) {
      const ts = Date.now().toString().slice(-8);
      const rnd = Math.floor(Math.random() * 9000 + 1000);
      this.form.barcode = `MSTK${ts}${rnd}`;
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

/* Modal de impresión de código de barras */
.barcode-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}
.barcode-modal {
  width: 100%;
  max-width: 480px;
  margin: 1rem;
}
.barcode-preview-wrapper {
  display: flex;
  justify-content: center;
  background: #f6f7f9;
  border: 1px dashed #ccc;
  border-radius: 6px;
  padding: 10px;
}
.barcode-label {
  width: 100mm;
  height: 50mm;
  max-width: 100%;
  background: #fff;
  border: 1px solid #ddd;
  padding: 4mm;
  display: flex;
  flex-direction: column;
  transform-origin: top center;
}
.barcode-label-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.barcode-label-name {
  font-size: 12pt;
  font-weight: bold;
  max-width: 60mm;
  word-break: break-word;
}
.barcode-label-price {
  font-size: 14pt;
  font-weight: bold;
}
.barcode-label-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.barcode-label-body svg {
  max-width: 90mm;
  max-height: 30mm;
}
</style>
